
define('text!templates/modules/calendar/calendar/calendar-component/item/item-duplicate-modal.html',[],function () { return '<div class="calendar-item-duplicate-body">\n    {{#IsAnimatedSession}}\n        <div class="duplicate-all-items-checkbox"></div>\n    {{/IsAnimatedSession}}\n    <div class="date-picker"></div>\n</div>\n';});

